/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'zoom-minus': {
    width: 22,
    height: 2,
    viewBox: '0 0 22 2',
    data: '<path pid="0" d="M22 0v2H0V0z" _fill="#000" fill-rule="evenodd"/>'
  }
})
